import { useMutation } from '@tanstack/react-query';

import { logger } from '@zep/core-logger';

import { AI_HTTP_CLIENT } from '@/api/ai/client';
import type { AchievementStandard } from '@/shared/features/ai-quiz-generation/types';
import { alertDialog } from '@/ui_v3';

import type { SearchFilter } from '../types';

interface SearchResponse {
  standards: AchievementStandard[]; // AI_HTTP_CLIENT가 자동으로 camelCase 변환
}

/**
 * 성취기준 검색 API 호출 훅
 * 학년, 과목, 키워드 필터를 사용하여 성취기준 검색
 */
export const useSearchStandards = () => {
  const mutation = useMutation({
    mutationFn: async (filter: SearchFilter) => {
      try {
        const response = await AI_HTTP_CLIENT.post<SearchResponse>(
          '/quiz-builder/search-standards',
          {
            query: filter.query.trim() || undefined,
            categoryIds: filter.categoryIds,
          },
        );
        return response.data.standards;
      } catch (_error) {
        alertDialog.open({
          header: {
            title: '성취기준 검색 중 오류가 발생했습니다.',
          },
        });
        logger.track('search_ai_std_error');
        return [];
      }
    },
  });

  const search = (filter: SearchFilter) => {
    // 카테고리나 키워드가 없으면 검색하지 않음
    if (!filter.categoryIds?.length && !filter.query.trim()) {
      mutation.reset(); // 기존 결과 초기화
      return;
    }
    mutation.mutate(filter);
  };

  return {
    search,
    isLoading: mutation.isPending,
    searchResults: mutation.data || [],
  };
};
